// src/pages/GetStarted.jsx

import { useNavigate, useLocation } from "react-router-dom";
import LanguageSelector from "../components/LanguageSelector";
import { useIntl } from "react-intl";

export default function GetStarted() {
  const navigate = useNavigate();
  const intl = useIntl();
  const { search } = useLocation();
  const currentLang = new URLSearchParams(search).get("lang") || "en";

  return (
    <>
      <div className="authpage-layout">
        <div className="authpage-left">
          <img src="/lugarlogopw.png" alt="LugarAI Logo" />
          <h1 className="hero-title">
            {intl.formatMessage({ id: "sloganTitle" })}
          </h1>
          <p className="hero-subtitle">
            {intl.formatMessage({ id: "sloganText" })}
          </p>
        </div>

        <div className="authpage-right">
          <div className="auth-form">
            <h2>{intl.formatMessage({ id: "getStarted" })}</h2>

            <button
              className="auth-button btn-primary"
              onClick={() => navigate(`/login?lang=${currentLang}`)}
            >
              {intl.formatMessage({ id: "login" })}
            </button>

            <button
              className="auth-button btn-text"
              onClick={() => navigate(`/sign-up?lang=${currentLang}`)}
            >
              {intl.formatMessage({ id: "signUp" })}
            </button>

            <div className="text-sm" style={{ marginTop: "1.5rem" }}>
              <a href={`/terms?lang=${currentLang}`}>
                {intl.formatMessage({ id: "terms" })}
              </a>
              &nbsp;&nbsp;
              <a href={`/privacy?lang=${currentLang}`}>
                {intl.formatMessage({ id: "privacy" })}
              </a>
            </div>
          </div>
        </div>
      </div>

      <footer className="auth-footer">
        <div className="left"><p>{intl.formatMessage({ id: 'footer.rights' })}</p></div>
        <div className="right">
          <div className="footer-language-selector">
            <LanguageSelector />
          </div>
        </div>
      </footer>
    </>
  );
}
